import type { loader } from '../root.tsx';
import { useRouteLoaderDataTyped } from './misc.js';

export function useRootLoaderData() {
  return useRouteLoaderDataTyped<typeof loader>('root');
}
